<app-remove-process-button [process]="job"></app-remove-process-button>
<app-check-process-button [job]="job"></app-check-process-button>